import React, { useState, useEffect } from "react";
import styles from "./index.module.less";
import logoImage from "@/assets/images/logo.png";
import { downloadToolNow } from "@/utils/constants.js";
import ContactModal from "./ContactModal";

export default function (props) {
  const [contactVisible, setContactVisible] = useState(false);
  const reload = () => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }
  return (
    <div className={styles.main}>
      <img className={styles.logo} onClick={reload} src={logoImage} />

      <span className={styles["tab-one"]} onClick={reload}>首页</span>
      <a
        href="https://www.bilibili.com/video/BV1t3411C72Y?pop_share=1"
        target="_blank"
        rel="noopener noreferrer"
      >
        <span className={styles.tab}>视频教程</span>
      </a>
      <a
        href="https://effectsstudio-manual.softsugar.com/basics/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <span className={styles.tab}>用户手册</span>
      </a>
      <a
        href="https://effectsstudio-manual.softsugar.com/questions1/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <span className={styles.tab}>常见问题</span>
      </a>

      <div className={styles.right}>
        {/* <span className={styles.cn}>中</span>
        <span className={styles.line}>|</span>
        <span className={styles.en}>En</span> */}
        <span className={styles.download} onClick={downloadToolNow}>立即下载</span>
        <span className={styles.contact} onClick={() => setContactVisible(true)}>联系我们</span>
      </div>
      <ContactModal visible={contactVisible} onClose={() => setContactVisible(false)} onToggle={() => setContactVisible(!contactVisible)} />
    </div>
  );
}
